export default [
    {
        name: '__slot:url',
        sortField: 'url',
        type: 'string',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'it1',
        sortField: 'it1',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it3',
        sortField: 'it3',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it5',
        sortField: 'it5',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it10',
        sortField: 'it10',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it50',
        sortField: 'it50',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true
    }
]
